import { render, staticRenderFns } from "./tab-other.vue?vue&type=template&id=27bd6674&scoped=true"
import script from "./tab-other.vue?vue&type=script&lang=js"
export * from "./tab-other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd6674",
  null
  
)

export default component.exports